__turbopack_context__.v({
  "pointlistpoint": "PointListPoint-module-scss-module__W6FXeW__pointlistpoint",
  "pointlistpoint__heading": "PointListPoint-module-scss-module__W6FXeW__pointlistpoint__heading",
  "pointlistpoint__number": "PointListPoint-module-scss-module__W6FXeW__pointlistpoint__number",
  "pointlistpoint__paragraph": "PointListPoint-module-scss-module__W6FXeW__pointlistpoint__paragraph",
  "top": "PointListPoint-module-scss-module__W6FXeW__top",
});
